// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.btn-custom-edit {
  background-color: #502eff;
  /* color: white; */
  /* width: 5rem; */
}

.btn-custom-edit:hover {
  background-color: #0071bc !important;
  color: white !important;
   border: 1px solid #0071bc;
}


.btn-custom-delete {
  background-color: white !important;
 
}

.btn-custom-delete:hover {
  background-color: #ee5d50 !important;
  border: 1px solid #ee5d50;
  color: white !important;
}

/* .btn-icon {
  width: 1.3rem;
  padding-bottom: 0.2rem;
}
.btn-custom-edit:hover .btn-icon,
.btn-custom-delete:hover .btn-icon {
    filter: brightness(1);
  color: white;
} */
tr,td{

    border-left: none !important;
    border-right: none !important;
  }
  table{
    border-radius: 8px !important;
  }

/* .btn-custom-edit, .btn-custom-delete {
    width: 5.5rem;
    border-radius: 5px;
    padding: 5px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    background-color: white;
    border: 1px solid transparent;
    transition: background-color 0.3s, filter 0.3s;
}

.btn-custom-edit {
    border-color: #502eff;
    color: #502eff;
}

.btn-custom-edit:hover {
    background-color: #ece9fe;
}

.btn-custom-delete {
    border-color: #ee5d50;
    color: #ee5d50;
    margin-left: 10px;
}

.btn-custom-delete:hover {
    background-color: #ffedea;
}

.icon-edit, .icon-delete {
    width: 1.3rem;
    margin-right: 5px;
    transition: filter 0.3s;
}

.btn-custom-edit:hover .icon-edit {
    filter: brightness(20);
}

.btn-custom-delete:hover .icon-delete {
    filter: brightness(5);
} */
`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/Master/master.css"],"names":[],"mappings":";AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;GACtB,yBAAyB;AAC5B;;;AAGA;EACE,kCAAkC;;AAEpC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;;;;;;;;GAQG;AACH;;IAEI,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;;AAEF;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2CG","sourcesContent":["\n.btn-custom-edit {\n  background-color: #502eff;\n  /* color: white; */\n  /* width: 5rem; */\n}\n\n.btn-custom-edit:hover {\n  background-color: #0071bc !important;\n  color: white !important;\n   border: 1px solid #0071bc;\n}\n\n\n.btn-custom-delete {\n  background-color: white !important;\n \n}\n\n.btn-custom-delete:hover {\n  background-color: #ee5d50 !important;\n  border: 1px solid #ee5d50;\n  color: white !important;\n}\n\n/* .btn-icon {\n  width: 1.3rem;\n  padding-bottom: 0.2rem;\n}\n.btn-custom-edit:hover .btn-icon,\n.btn-custom-delete:hover .btn-icon {\n    filter: brightness(1);\n  color: white;\n} */\ntr,td{\n\n    border-left: none !important;\n    border-right: none !important;\n  }\n  table{\n    border-radius: 8px !important;\n  }\n\n/* .btn-custom-edit, .btn-custom-delete {\n    width: 5.5rem;\n    border-radius: 5px;\n    padding: 5px;\n    font-size: 14px;\n    font-weight: 700;\n    cursor: pointer;\n    background-color: white;\n    border: 1px solid transparent;\n    transition: background-color 0.3s, filter 0.3s;\n}\n\n.btn-custom-edit {\n    border-color: #502eff;\n    color: #502eff;\n}\n\n.btn-custom-edit:hover {\n    background-color: #ece9fe;\n}\n\n.btn-custom-delete {\n    border-color: #ee5d50;\n    color: #ee5d50;\n    margin-left: 10px;\n}\n\n.btn-custom-delete:hover {\n    background-color: #ffedea;\n}\n\n.icon-edit, .icon-delete {\n    width: 1.3rem;\n    margin-right: 5px;\n    transition: filter 0.3s;\n}\n\n.btn-custom-edit:hover .icon-edit {\n    filter: brightness(20);\n}\n\n.btn-custom-delete:hover .icon-delete {\n    filter: brightness(5);\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
